export interface JobOpening {
  id: string;
  title: string;
  department: string;
  location: string;
  type: string;
  experience: string;
  salary: string;
  skills: string[];
  description: string;
  requirements: string[];
  responsibilities: string[];
  benefits: string[];
  isActive: boolean;
  postedDate: string;
  applicationDeadline: string;
}

export const jobOpenings: JobOpening[] = [
  {
    id: 'senior-fullstack-dev-001',
    title: 'Senior Full Stack Developer',
    department: 'Engineering',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '5-8 years',
    salary: '₹15-25 LPA',
    skills: ['React', 'Node.js', 'MongoDB', 'AWS', 'TypeScript'],
    description: 'We are looking for an experienced Full Stack Developer to join our dynamic team and work on cutting-edge web applications.',
    requirements: [
      'Bachelor\'s degree in Computer Science or related field',
      '5+ years of experience in full-stack development',
      'Strong proficiency in React, Node.js, and MongoDB',
      'Experience with cloud platforms (AWS/Azure)',
      'Knowledge of TypeScript and modern JavaScript frameworks'
    ],
    responsibilities: [
      'Develop and maintain web applications using React and Node.js',
      'Design and implement RESTful APIs',
      'Collaborate with cross-functional teams',
      'Optimize applications for maximum speed and scalability',
      'Mentor junior developers'
    ],
    benefits: [
      'Competitive salary and performance bonuses',
      'Health insurance and wellness programs',
      'Flexible working hours and remote work options',
      'Professional development opportunities'
    ],
    isActive: true,
    postedDate: '2024-01-15',
    applicationDeadline: '2024-02-15'
  },
  {
    id: 'devops-engineer-002',
    title: 'DevOps Engineer',
    department: 'Infrastructure',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '3-6 years',
    salary: '₹12-20 LPA',
    skills: ['AWS', 'Docker', 'Kubernetes', 'Jenkins', 'Terraform'],
    description: 'Join our DevOps team to build and maintain scalable infrastructure for our growing portfolio of applications.',
    requirements: [
      'Bachelor\'s degree in Engineering or related field',
      '3+ years of experience in DevOps/Infrastructure',
      'Strong knowledge of AWS services',
      'Experience with containerization (Docker, Kubernetes)',
      'Proficiency in Infrastructure as Code (Terraform)'
    ],
    responsibilities: [
      'Design and implement CI/CD pipelines',
      'Manage cloud infrastructure on AWS',
      'Monitor system performance and reliability',
      'Automate deployment processes',
      'Ensure security best practices'
    ],
    benefits: [
      'Competitive compensation package',
      'Learning and certification opportunities',
      'Flexible work arrangements',
      'Team building activities'
    ],
    isActive: true,
    postedDate: '2024-01-10',
    applicationDeadline: '2024-02-10'
  },
  {
    id: 'ui-ux-designer-003',
    title: 'UI/UX Designer',
    department: 'Design',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '2-5 years',
    salary: '₹8-15 LPA',
    skills: ['Figma', 'Adobe XD', 'Sketch', 'Prototyping', 'User Research'],
    description: 'Create beautiful and intuitive user experiences for our web and mobile applications.',
    requirements: [
      'Bachelor\'s degree in Design or related field',
      '2+ years of UI/UX design experience',
      'Proficiency in design tools (Figma, Adobe XD)',
      'Strong portfolio demonstrating design skills',
      'Understanding of user-centered design principles'
    ],
    responsibilities: [
      'Create wireframes, prototypes, and high-fidelity designs',
      'Conduct user research and usability testing',
      'Collaborate with development teams',
      'Maintain design systems and style guides',
      'Present design concepts to stakeholders'
    ],
    benefits: [
      'Creative and collaborative work environment',
      'Access to latest design tools and software',
      'Professional growth opportunities',
      'Flexible working hours'
    ],
    isActive: true,
    postedDate: '2024-01-12',
    applicationDeadline: '2024-02-12'
  },
  {
    id: 'data-scientist-004',
    title: 'Data Scientist',
    department: 'Analytics',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '3-7 years',
    salary: '₹18-30 LPA',
    skills: ['Python', 'Machine Learning', 'TensorFlow', 'SQL', 'Statistics'],
    description: 'Work with large datasets to extract insights and build predictive models for our clients.',
    requirements: [
      'Master\'s degree in Data Science, Statistics, or related field',
      '3+ years of experience in data science',
      'Strong programming skills in Python/R',
      'Experience with machine learning frameworks',
      'Knowledge of statistical analysis and modeling'
    ],
    responsibilities: [
      'Develop machine learning models and algorithms',
      'Analyze large datasets to extract insights',
      'Create data visualizations and reports',
      'Collaborate with business stakeholders',
      'Deploy models to production environments'
    ],
    benefits: [
      'Competitive salary with performance incentives',
      'Access to cutting-edge technology and tools',
      'Conference attendance and training opportunities',
      'Collaborative research environment'
    ],
    isActive: true,
    postedDate: '2024-01-08',
    applicationDeadline: '2024-02-08'
  },
  {
    id: 'mobile-developer-005',
    title: 'Mobile App Developer',
    department: 'Engineering',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '2-5 years',
    salary: '₹10-18 LPA',
    skills: ['React Native', 'Flutter', 'iOS', 'Android', 'Firebase'],
    description: 'Develop high-quality mobile applications for iOS and Android platforms.',
    requirements: [
      'Bachelor\'s degree in Computer Science or related field',
      '2+ years of mobile app development experience',
      'Proficiency in React Native or Flutter',
      'Knowledge of native iOS/Android development',
      'Experience with mobile app deployment'
    ],
    responsibilities: [
      'Develop cross-platform mobile applications',
      'Optimize app performance and user experience',
      'Integrate with backend APIs and services',
      'Test applications on various devices',
      'Maintain and update existing applications'
    ],
    benefits: [
      'Opportunity to work on innovative mobile projects',
      'Latest mobile development tools and devices',
      'Flexible work schedule',
      'Professional development support'
    ],
    isActive: true,
    postedDate: '2024-01-14',
    applicationDeadline: '2024-02-14'
  },
  {
    id: 'cybersecurity-specialist-006',
    title: 'Cybersecurity Specialist',
    department: 'Security',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '4-8 years',
    salary: '₹16-28 LPA',
    skills: ['Penetration Testing', 'CISSP', 'Network Security', 'Compliance', 'Risk Assessment'],
    description: 'Protect our clients\' digital assets and ensure compliance with security standards.',
    requirements: [
      'Bachelor\'s degree in Cybersecurity or related field',
      '4+ years of cybersecurity experience',
      'Security certifications (CISSP, CEH, etc.)',
      'Experience with penetration testing tools',
      'Knowledge of compliance frameworks'
    ],
    responsibilities: [
      'Conduct security assessments and audits',
      'Implement security policies and procedures',
      'Monitor and respond to security incidents',
      'Provide security training to staff',
      'Ensure compliance with industry standards'
    ],
    benefits: [
      'Competitive compensation and bonuses',
      'Certification and training support',
      'Cutting-edge security tools and technologies',
      'Opportunity to work with diverse clients'
    ],
    isActive: true,
    postedDate: '2024-01-11',
    applicationDeadline: '2024-02-11'
  }
];

// Function to get active job openings
export const getActiveJobOpenings = (): JobOpening[] => {
  return jobOpenings.filter(job => job.isActive);
};

// Function to get job by ID
export const getJobById = (id: string): JobOpening | undefined => {
  return jobOpenings.find(job => job.id === id);
};

// Function to add new job opening (for admin use)
export const addJobOpening = (job: Omit<JobOpening, 'id'>): JobOpening => {
  const newJob: JobOpening = {
    ...job,
    id: `job-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
  };
  jobOpenings.push(newJob);
  return newJob;
};

// Function to update job opening
export const updateJobOpening = (id: string, updates: Partial<JobOpening>): JobOpening | null => {
  const jobIndex = jobOpenings.findIndex(job => job.id === id);
  if (jobIndex === -1) return null;
  
  jobOpenings[jobIndex] = { ...jobOpenings[jobIndex], ...updates };
  return jobOpenings[jobIndex];
};

// Function to deactivate job opening
export const deactivateJobOpening = (id: string): boolean => {
  const job = getJobById(id);
  if (!job) return false;
  
  job.isActive = false;
  return true;
};